<template>
  <div class="landing-page" style="padding-top: 0;">
    <div class="login-content">
      <div class="login login-send">
        <div class="">
          <div class="" style="text-align: center">
            <img style="width: 35%;margin-top: 50px" src="../../static/images/logo.png">
          </div>
          <div class="middle">
            <img src="../../static/images/login_pic1.png">
          </div>
          <div class="login-tip">
            <span>{{ $t('loginTips') }}</span>
          </div>
          <div class="login-overlay">
            <div class="input-div">
              <div class="input-item mt20"
                   style="background: rgba(255, 255, 255, 0.85);">
                <div class="input-item2">
                  <span class="app-en">
                    <img style="vertical-align: middle;" src="../../static/images/input_09.png">
                  </span>
                  <input class="input" style="color: black" v-model="mobile" type="text"
                         maxlength="15"
                         inputmode="numeric"
                         pattern="[0-9]*">
                </div>
              </div>
            </div>
            <div class="ac mt30 por">
              <button class="login-button" @click="handleLogin" type="button">
                <span class="login-button-image" :class="isEN === 'en' ? 'login-en' : 'login-mm'"></span>
              </button>
            </div>
          </div>
          <div class="ac otp-b disflex por login-footer">
            <div class="icon icon2 login_help" @click="getChange('termsAndCondition')">{{ $t('TC') }}</div>
            <div class="icon icon2 login_help" @click="getChange('faq')">{{ $t('FAQ') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import CryptoJS from '../../static/js/crypto-js.min.js'

export default {
  data() {
    return {
      isEN: "bur",
      list: [],
      mobile: '',
      password: '',
    }
  },
  created() {
    if (localStorage.getItem('lang')) {
      this.isEN = localStorage.getItem('lang');
    }
    if (this.$route.query.msidn) {
      let ss = this.aesEcbDecrypt(this.$route.query.msidn);
      this.mobile = this.dealPhone_2(ss);
    }
    //渠道是atomber 且 有号码的
    let channelId = this.$route.query.channelId;
    if (channelId == 'atomber' && this.mobile){
      //查询订阅状态 直接到daily cg
      this.handleLogin();
    }
  },
  methods: {
    getChange(type) {
      let that = this;
      that.$router.push({path: '/' + type})
    },
    handleLogin() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = that.getMobile();
      const userAgent = navigator.userAgent;
      const deviceId = this.getDeviceId();
      let data = {
        mobile: mobile,
        user_agent: userAgent,
        device_id: deviceId
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/user_status', data, r => {
        that.$parent.loadModal(false);
        that.$parent.returnCode(r, function () {
          if (r.code == 0) {
            that.$utils.alertText(r.msg, 80);
            return;
          }
          if (r.data.status == 1 || r.data.status == -2) {
            if (r.data.change_device) {
              that.goOtpLogin();
              return;
            }
            that.login();
            return;
          }
          that.goSub();
        })
      })

    },
    goOtpLogin() {
      let that = this
      let mobile = that.getMobile();
      let encryptedMobile = that.aesEcbEncrypt(mobile);
      this.$router.push({path: '/otp', query: {msidn: encryptedMobile}});
    },
    goSub() {
      this.$router.push({
        path: '/sub',
        query: this.buildCleanQuery({
          mobileInput: this.mobile
        })
      });
    },
    buildCleanQuery(extra = {}) {
      const query = {};
      Object.keys(this.$route.query || {}).forEach(key => {
        if (!key || /^\d+$/.test(key)) {
          return;
        }
        const value = this.$route.query[key];
        if (value === undefined || value === null || value === '') {
          return;
        }
        if (Array.isArray(value)) {
          const values = value.filter(item => item !== undefined && item !== null && item !== '');
          if (values.length) {
            query[key] = values;
          }
          return;
        }
        query[key] = value;
      });
      delete query.mobile;
      delete query.mobileInput;
      delete query.msidn;
      delete query.subappid;

      Object.keys(extra).forEach(key => {
        const value = extra[key];
        if (value === undefined || value === null || value === '') {
          delete query[key];
          return;
        }
        query[key] = value;
      });

      return query;
    },
    login() {
      let that = this;
      if (that.mobile === "") {
        that.$utils.alertText(that.$t('phone_error'), 80)
        return
      }
      let mobile = that.getMobile();
      let encryptedMobile = that.aesEcbEncrypt(mobile);
      that.$parent.loadModal(true);
      if(this.$route.query.room_id){
        window.location.href = "https://app.liarrow.com/app?msidn=" + encodeURIComponent(encryptedMobile) + '&room_id=' + this.$route.query.room_id;
      }else{
        window.location.href = "https://app.liarrow.com/app?msidn=" + encodeURIComponent(encryptedMobile);
      }

    },
    getMobile(){
      let mobile = '09' + this.mobile
      mobile = this.dealPhone(mobile)
      return mobile;
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, '');
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, '');
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('96') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id');
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('device_id', id);
      }
      return id;
    },
    aesEcbEncrypt(plaintext) {
      var key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
      var data = CryptoJS.enc.Utf8.parse(plaintext);
      var blockSize = 16;
      var padLen = (blockSize - (data.sigBytes % blockSize)) % blockSize;
      var words = data.words.slice(0);
      var wordArray = CryptoJS.lib.WordArray.create(words, data.sigBytes + padLen);

      var encrypted = CryptoJS.AES.encrypt(wordArray, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.NoPadding
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
    aesEcbDecrypt(ciphertextBase64) {
      try {
        const key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
        const encrypted = CryptoJS.enc.Base64.parse(ciphertextBase64);
        const decrypted = CryptoJS.AES.decrypt(
          {ciphertext: encrypted},
          key,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.NoPadding
          }
        );
        return decrypted.toString(CryptoJS.enc.Utf8).replace(/\0+$/, "");
      } catch (e) {
        return "";
      }
    },
  }
}
</script>
<style scoped>
.landing-page {
  min-height: 100vh;
  background-size: cover !important;
}

.otp-b {
  justify-content: space-evenly;
}

.login-overlay {
  z-index: 10;
}

.middle img {
  top: 300px !important;
  width: 520px !important;
  max-width: 90% !important;
}

.input-div input.input::placeholder {
  color: #ffffff !important;
  opacity: 1 !important;
}

.input-div .input-item {
  width: 86% !important;
  height: 76px !important;
  border-radius: 60px !important;
  margin: 0 auto !important;
}

.input-div .input-item2 {
  height: 76px !important;
  border-radius: 60px !important;
}

.input-div .app-en {
  padding: 0 !important;
  margin-right: 10px;
}

.input-div .app-en img {
  width: 120px !important;
  height: auto;
  display: inline-block;
}

.input-div input.input {
  height: 76px !important;
  line-height: 76px !important;
  font-size: 42px !important;
  font-weight: 700 !important;
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  border-radius: 0 !important;
}

.login-button {
  width: min(320px, 80vw);
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.login-button-image {
  display: block;
  width: 100%;
  aspect-ratio: 53 / 22;
  margin: 0 auto;
  background-size: 100% 100% !important;
}

.login-en {
  background: url(../../static/images/login_en.png) no-repeat center !important;
}

.login-mm {
  background: url(../../static/images/login_mm.png) no-repeat center !important;
}

.login-footer {
  margin-top: 270px !important;
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue